import _ from 'lodash'
import {propertiesResponseAction} from 'module/Properties/action/PropertiesAction';
import {createReducer} from '@reduxjs/toolkit';

const PropertiesReducer = createReducer<{ [cid in string]?: string }>({}, builder => builder
	.addCase(propertiesResponseAction, (state, {payload}) => {
		const received = _.transform(payload, (result, p) => {
			result[p.compositeId] = p.value;
			return result;
		}, {} as { [cid in string]?: string });
		return {...state, ...received};
	}),
);

export const PropertiesReducerNS = {Properties: PropertiesReducer}
export type PropertiesStateType = { Properties: ReturnType<typeof PropertiesReducerNS.Properties> }